<template>
  <div>
    <a-modal
      :visible.sync="dialogVisible"
      title=""
      width="650px"
      footer=""
      @ok="handleOk"
      @cancel="handleOk"
    >
      <a-tabs v-model="activeKey" v-show="dialogVisible">
        <a-tab-pane key="1" tab="实时">
          <EZUIKitJs
            key="1"
            :EZUIKitToken="EZUIKitToken"
            :dialogVisible="dialogVisible"
            :EZUIKitCode="EZUIKitCode"
            :EZUIKitChanneln="EZUIKitChanneln"
            :activeKey="activeKey"
          />
        </a-tab-pane>
      
      </a-tabs>
    </a-modal>
  </div>
</template>
  
  <script>
// 实时
import EZUIKitJs from "../../../components/common/EZUIKitJs.vue";

// 回放

export default {
  props: ["DialogFlg", "eq_token", "eq_code","eq_channeln"],
  data() {
    return {
      activeKey: "1",
      dialogVisible: false,
      // 回放
      PlaybackToken: "",
      PlaybackCode: "",

      // 监控
      EZUIKitToken: "",
      EZUIKitCode: "",
      EZUIKitChanneln:1,
    };
  },
  components: {
    EZUIKitJs,
  },
  watch: {
    dialogVisible() {
      this.$emit("xiaoshi", this.dialogVisible);
    },
    DialogFlg(old, newVal) {
      console.log("eq_code", this.eq_code);
      this.dialogVisible = this.DialogFlg;
      this.activeKey = "1";
      this.PlaybackCode = this.eq_code;
      this.EZUIKitCode = this.eq_code;
      this.PlaybackToken = this.eq_token;
      this.EZUIKitToken = this.eq_token;
      this.EZUIKitChanneln = this.eq_channeln;
    },
  },

  mounted: () => {},
  methods: {
    handleOk() {
      this.dialogVisible = false;
    },
  },
};
</script>
  